import React from 'react';
import { motion, DragControls } from 'framer-motion';
import KikiBotIcon from '../../assets/Chat-bot_widget.png';
import { useTelemetry } from '../../hooks/useTelemetry';
import { MODULES } from '../../telemetry/constants/modules';
import { ACTIONS } from '../../telemetry/constants/actions';

interface FloatingButtonProps {
  onClick: () => void;
  unreadCount: number;
  dragControls: DragControls;
}

const FloatingButton: React.FC<FloatingButtonProps> = ({ onClick, unreadCount, dragControls }) => {
  const { trackAction } = useTelemetry({ module: MODULES.AI_ASSISTANT, submodule: 'Floating Button' });

  return (
    <motion.button
      onClick={() => {
        onClick();
        trackAction(ACTIONS.OPEN_CHATBOT, 'Open AI Chat');
      }}
      onPointerDown={(e) => dragControls.start(e)}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      exit={{ scale: 0 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="relative flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] border border-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-100 transition-shadow cursor-pointer"
      aria-label="Ask Kiki AI Assistant"
    >
      <motion.img
        src={KikiBotIcon}
        alt="Ask Kiki"
        className="w-12 h-12 object-contain pointer-events-none"
        animate={{ y: [0, -3, 0] }}
        transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
      />
      {unreadCount > 0 && (
        <span className="absolute top-0 right-0 flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-red-500 border-2 border-white rounded-full">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </motion.button>
  );
};

export default FloatingButton;
